import { render, staticRenderFns } from "./chinaEurope.vue?vue&type=template&id=1f8a941d&"
import script from "./chinaEurope.vue?vue&type=script&lang=js&"
export * from "./chinaEurope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports